export default {
    patient_seen: 'Patient seen',
    patient_not_seen: 'Patient not seen',
    consultation_saved: 'Consultation report saved',
    consultation_skipped: 'Consultation report skipped',
    need_your_attention: 'Referrals need your attention',
}
